



















import { Component, Mixins } from "vue-property-decorator";
import MethodsWindow from "basis/components/login/MethodsWindow.vue";
import PhoneCodeWindow from "basis/components/login/PhoneCodeWindow.vue";
import PhoneNumberWindow from "basis/components/login/PhoneNumberWindow.vue";
import mixins from "@/mixins";

@Component({
  components: {
    MethodsWindow,
    PhoneCodeWindow,
    PhoneNumberWindow
  }
})
class Login extends Mixins(mixins.publicPage) {
  step = 0;

  method = 0;

  phone = "";

  country = "86";

  loading = false;

  get title() {
    return this.$t("common.login") as string;
  }

  get meta() {
    return {
      phoneNumber: `+${this.country} ${this.phone}`
    };
  }

  handleUseSms() {
    this.step = 1;
  }

  handleUseMixin() {
    this.step = 0;
  }

  handleToPhoneCodeWindow() {
    this.step = 2;
  }

  toScreen(index) {
    this.step = index;
  }
}
export default Login;
